import {Color} from 'three';


export class ColorConverter {

    public transformIndex(i: number) {

        i++;
        // tslint:disable-next-line:no-bitwise
        const r = (i & 0x000000FF) >> 0;
        // tslint:disable-next-line:no-bitwise
        const g = (i & 0x0000FF00) >> 8;
        // tslint:disable-next-line:no-bitwise
        const b = (i & 0x00FF0000) >> 16;


        return new Color(r / 255, g / 255, b / 255);
    }

    public transformColor(r: number, g: number, b: number) {
        return (r + g * 256 + b * 256 * 256) - 1;
    }

    public transformColor_Texture(r: number, g: number, b: number, step: number) {
        return (((r * 256 * 256 + g * 256 + b) / step) - 1) * 4;
    }
}
